
import { Vue, Component } from "vue-property-decorator";
import { getEmployeesTraffics } from "@/api/offers";
import AdministrationOffersLayout from "@/components/layout/AdministrationOffersLayout.vue";

@Component({
    methods: { getEmployeesTraffics },
    components: { AdministrationOffersLayout },
})

export default class Traffics extends Vue {}
